import { Skeleton } from 'src/components/atoms';
import { GridContainer, GridItem } from 'src/components/layout';

export const MediaContainerSkeleton = () => {
  return (
    <GridContainer spacing={1}>
      {[0, 1, 2].map(mockValue => (
        <GridItem key={mockValue}>
          <Skeleton sx={{ height: '5.75rem', width: '5.75rem', mb: '0.25rem' }} />
        </GridItem>
      ))}
    </GridContainer>
  );
};
